module.exports = __webpack_public_path__ + "static/media/P1-Banner perfil.e62e015e.jpg";